<template lang='pug'>
v-list(class='complex-meta' dense)
  v-list-tile
    v-list-tile-content(class='grey--text') Домов в продаже / всего
    v-list-tile-content(class='align-end') {{ complex.objects_sale }}/{{ complex.objects_all }}
  //- v-list-tile
  //-   v-list-tile-content(class='grey--text') Сдано домов
  //-   v-list-tile-content(class='align-end') {{ complex.objects_finish }}
  v-list-tile
    v-list-tile-content(class='grey--text') Стоимость от
    v-list-tile-content(class='align-end') {{ complex.price.min | currency(' ', 0,{ thousandsSeparator: ' ' }) }} руб.
  v-list-tile
    v-list-tile-content(class='grey--text') Площадь квартир, м.кв.
    v-list-tile-content(class='align-end') {{ complex.square.min }} &mdash; {{ complex.square.max }}
  v-list-tile
    v-list-tile-content(class='grey--text') Квартир в продаже
    v-list-tile-content(class='align-end') {{ complex.placements_sale }}
  v-list-tile
    v-list-tile-content(class='grey--text') Срок сдачи объекта
    v-list-tile-content(class='align-end') {{ date | date }}
</template>

<script>
export default {
  props: ['date', 'complex']
}
</script>

<style scoped>
.complex-meta >>> .v-list__tile {
  height: 30px;
}
</style>
